import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from '../index.scss';
import searchBoxCss from '../styles/search.scss';
import DropDownList from '../../dropdown-list/index';
import { FULL_WIDTH } from '../../dropdown-list/constant';
import messages from '../messages';
import TextInput from '../../text-input';

const AssignCourseFilter = (props) => {
    const { intl,
        yearGroups,
        countries,
        handleOnYearGroupChange,
        handleOnCountryChange,
        handleOnSearchCourse,
        searchQuery,
        disableSearch,
        disableYearGroup,
        selectedYearGroupId,
        isLoadingCountryYearGroups,
        selectedCountryId
    } = props;

    const countriesList = countries.slice(0);

    const clearText = true;

    const getSubHeading = () => intl.formatMessage(messages.newCourses);

    return (
        <div>
            <div className={css.defaultCourse}>
                <div className={css.heading}>{intl.formatMessage(messages.startCourse)}</div>
                <div className={css.subHeading}>{getSubHeading()}</div>
                <DropDownList
                    name="countries"
                    onChange={handleOnCountryChange}
                    optionKey="code"
                    options={countriesList}
                    optionText="name"
                    placeholder={intl.formatMessage(messages.defaultOptionCountry)}
                    value={selectedCountryId}
                    variant={FULL_WIDTH}
                />
                <DropDownList
                    disabled={disableYearGroup}
                    isLoading={isLoadingCountryYearGroups}
                    name="yearGroups"
                    onChange={handleOnYearGroupChange}
                    optionKey="yearGroupEnum"
                    options={yearGroups}
                    optionText="longName"
                    placeholder={intl.formatMessage(messages.selectGroup)}
                    value={selectedYearGroupId}
                    variant={FULL_WIDTH}
                />
                <div className={css.searchContainer}>
                    <TextInput
                        clearText={clearText}
                        css={searchBoxCss}
                        disabled={disableSearch}
                        handleOnChange={handleOnSearchCourse}
                        placeholder={intl.formatMessage(messages.searchCourse)}
                        type="text"
                        value={searchQuery}
                    />
                </div>
            </div>
        </div>
    );
};

AssignCourseFilter.propTypes = {
    intl: intlShape.isRequired,
    yearGroups: PropTypes.array,
    countries: PropTypes.array,
    handleOnYearGroupChange: PropTypes.func,
    handleOnCountryChange: PropTypes.func,
    handleOnSearchCourse: PropTypes.func,
    searchQuery: PropTypes.string,
    disableSearch: PropTypes.bool,
    disableYearGroup: PropTypes.bool,
    isLoadingCountryYearGroups: PropTypes.bool,
    selectedYearGroupId: PropTypes.string,
    selectedCountryId: PropTypes.string
};

export default injectIntl(styleable(css)(AssignCourseFilter));



// WEBPACK FOOTER //
// ./app/components/assign-course-conquest/pages/assign-course-filter.js